import { Component, OnInit, Input } from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { Observable, of } from 'rxjs';
import { GridData } from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { ReviewProposalPartInfo } from 'src/app/models/internal/reviewproposalpartinfo2';
import * as moment from 'moment/moment';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { Constants } from 'src/app/core/constants';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { PackageLevelTemplate } from '../../models/packageleveltemplate';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { AppGlobalDataProperties } from 'src/app/core/appglobaldata';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { QueryPackageTemplatesForSupplierDTO } from 'src/app/models/internal/query-packagetemplates-forsupplier-dto';
import { QueryPackageTemplatesForPEDTO } from 'src/app/models/internal/query-packagetemplates-for-pe-dto';
import { PackageLevelTemplateDTO } from 'src/app/models/internal/packageleveltemplate-dto';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PackageType } from 'src/app/models/packagetype';
import { TransportMode } from 'src/app/models/transportmode';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { SearchFilterCondition } from 'src/app/models/internal/searchfiltercondition';
import { PackageMaterial } from 'src/app/models/packagematerial';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';

@Component({
    selector: 'app-packagelevel-template-list',
    templateUrl: './packagelevel-template-list.component.html',
    styleUrls: ['./packagelevel-template-list.component.scss'],
})
export class PackageLevelTemplateListComponent extends BaseGridPage implements OnInit {
    isTeslaCreatedList: any[] = [];
    packageLevelTemplateList: PackageLevelTemplateDTO[];
    allItemsCheckBoxSelected: boolean = false;
    updateProposalStatusDTO = new UpdateProposalStatusDTO();
    locStorage = Constants.localStorageKeys;
    filterForm: FormGroup;
    packageTypeList: PackageType[];
    transportModeList: TransportMode[];
    packageMaterialList: PackageMaterial[];
    isEnabled = [{text: 'True', value: 1}, {text: 'False', value: 0}];

    constructor(
        private dataService: DataService,
        private proposalService: ProposalService,
        private router: Router,
        private fb: FormBuilder,
        private appGlobalDataService: AppGlobalDataService,
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings,
            private toastService: ToastService
    ) {
        super(localstorageService, logger, appSettings);
        this.filterForm = this.fb.group({
            IsTeslaCreated: this.showSupplierData() ?  0 : 1,
            PackageTypeId: [null],
            TransportModeId: [null],
            PackageMaterialId: [null],
            TeslaEquipmentCode: [null],
            Enabled: 1
        });
        this.isTeslaCreatedList.push({'Description': 'Tesla', 'Value': 1});
        if (this.showSupplierData()) {
            this.isTeslaCreatedList.push({'Description': 'Self', 'Value': 0});
        } else {
            this.isTeslaCreatedList.push({'Description': 'Suppliers', 'Value': 0});
        }
    }

    ngOnInit() {
        this.initFilterValues();
        this.getPackageTypes();
        this.getTrasportModes();
        this.getMaterials();
        this.fillGrid();
    }
    fillGrid(): void {
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
        this.getPackageTemplates();
    }
    UpdateFilter() {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageTypeId');
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'IsTeslaCreated', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'TransportModeId');
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageMaterialId');
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'TeslaEquipmentCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'Enabled', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }

    reviewTemplate(id: number) {
        window.open('viewpackageleveltemplate/' + id, '_blank');
    }

    getStatus(from:string, to: string) {

        if (new Date(to) < new Date()) {
            return 'Inactive';
        }

        return 'Active';
    }


    getPackageTemplates() {
        this.UpdateFilter();
        if (this.showSupplierData()) {
            const queryPackageTemplatesForSupplierDTO: QueryPackageTemplatesForSupplierDTO = new QueryPackageTemplatesForSupplierDTO();
            queryPackageTemplatesForSupplierDTO.SearchFilter = this.filter;
            queryPackageTemplatesForSupplierDTO.SupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode);


            this.dataService
            .getPackageTemplatesListForSupplier(queryPackageTemplatesForSupplierDTO)
            .subscribe((response: any) => {
                if (response != null) {
                    this.packageLevelTemplateList = response.Data;
                    this.gridView = of({
                        data: response.Data,
                        total: response.Total ? response.Total : 0,
                    });
                }
            });
        } else {
            const queryPackageTemplatesForPEDTO: QueryPackageTemplatesForPEDTO = new QueryPackageTemplatesForPEDTO();
            queryPackageTemplatesForPEDTO.SearchFilter = this.filter;
            this.dataService
            .getPackageTemplatesListForPE(queryPackageTemplatesForPEDTO)
            .subscribe((response: any) => {
                if (response != null) {
                    this.packageLevelTemplateList = response.Data;
                    this.gridView = of({
                        data: response.Data,
                        total: response.Total ? response.Total : 0,
                    });
                }
            });
        }
    }

    canEditTemplate(dataItem) {
        
        if (dataItem.PackageTypeId == 1) {
            return !this.IsSupplier;
        }

        if (dataItem.proposalLevelUseCount > 0) {
            return false;
        }

        if (dataItem.IsTeslaCreated) {
            return !this.IsSupplier;
        }

        return true;
    }

    formatDate(unformattedDate: Date) {
        return Helper.formatDate(unformattedDate);
    }

    createPackageTemplate() {
        this.router.navigate(['../', 'packageleveltemplate']);
    }
    navigateToUpdate(id: number) {
        this.router.navigate(['/packageleveltemplate', id] );
    }
    getPackageLevelDescription(level: Number) {
        let desc = '';
        switch (level) {
            case 1: {
                desc = 'Primary';
                break;
            }
            case 2: {
                desc = 'Secondary';
                break;
            }
            case 3: {
                desc = 'Tertiary';
                break;
            }
        }
        return desc;
    }
    getPackageTypes() {
        this.dataService.getPackageTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageTypeList = response.Data;
            }
        });
    }
    getTrasportModes() {
        this.dataService.getTransportModes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.transportModeList = response.Data;
            }
        });
    }
    getMaterials() {
        this.dataService.getAllMaterials().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageMaterialList = response.Data;
            }
        });
    }

    clearFilter() {
        this.filterForm.reset();
        this.mainGrid = undefined;
        this.search();
    }
    showSupplierData() {
        return (this.IsSupplier || this.IsLoggedInAsSupplier);
    }

    //tms-34675 Show dims in metric on summary screen when plt is created in metric
    getDimensionBasedonUnit(length: number, width: number, height: number, uomsystemId: number) {
        if (uomsystemId == Constants.METRIC_UOM_ID) {
            length = Helper.roundto8(length * Constants.IMPERIAL_DIM_FACTOR);
            width = Helper.roundto8(width * Constants.IMPERIAL_DIM_FACTOR);
            height = Helper.roundto8(height * Constants.IMPERIAL_DIM_FACTOR);
        }

        return length + ' (L) x ' + width + ' (W) x ' + height + ' (H)'

    }

    getWeightbasedonUnit(weight: number, uomsystemId: number) {
        if (uomsystemId == Constants.METRIC_UOM_ID) {
            weight = Helper.roundto8(weight / Constants.IMPERIAL_WEIGHT_FACTOR);
        }
        return weight;
    }
}
